module.exports = __webpack_public_path__ + "static/img/蒙版组 12.bf29219.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inAndOut/cancelled/images/蒙版组 12.png
// module id = 9OOM
// module chunks = 0